/**
 * Enum representing different types of toasts.
 * Each value corresponds to a specific toast type, such as 'Success' or 'Error'.
 */
export enum ToastType {
  /**
   * Info type toast:
   * Used to display Information messages or notifications.
   */
  Info = 'Info',
  /**
   * Success type toast:
   * Used to display success messages or notifications.
   */
  Success = 'Success',

  /**
   * Error type toast:
   * Used to display error messages, alerts, or notifications about failures.
   */
  Error = 'Error',
}
